export type FetchSpotifyAccountIsLinkedResponse = {
  status: boolean;
};

async function fetchSpotifyAccountIsLinked({
  userId,
}: {
  userId: number;
}): Promise<FetchSpotifyAccountIsLinkedResponse> {
  const response = await fetch(
    `/api/proxy/v3/users/${userId}/spotify/account/isLinked`,
    {
      method: 'GET',
      credentials: 'same-origin',
    }
  );
  if (response.ok) {
    return response.json();
  }
  throw new Error(`${response.status} : ${response.statusText}`);
}

export { fetchSpotifyAccountIsLinked };
